import {atom} from "jotai";
import {processRows} from "../../helpers";
import {workLogsAtom} from "./workLogs";
import {queuesMapAtom} from "./queues";
import {dateFormatAtom} from "./dateFormat";
import {resultGroupsAtom} from "./resultGroups";
import {highlightTimeAtom} from "./highlightTime";
import {datesAtom} from "./dates";
import {selectedUsersAtom} from "./users";
import {usersMapAtom} from "./users";
import {RESULT_GROUP_WORKER} from "../../constants";

export const resultRowsAtom = atom(get => {
    const rows = processRows(
        get(workLogsAtom),
        get(queuesMapAtom),
        get(dateFormatAtom),
        get(resultGroupsAtom),
        get(highlightTimeAtom),
        get(datesAtom)
    );
    
    // Если нет строк кроме "Итого", но есть RESULT_GROUP_WORKER, создаем строку пользователя
    const resultGroups = get(resultGroupsAtom);
    const hasWorkerGroup = resultGroups.includes(RESULT_GROUP_WORKER);
    const hasOnlyTotalRow = rows.length === 1 && rows[0].isSummary;
    
    if (hasWorkerGroup && hasOnlyTotalRow) {
        const selectedUsers = get(selectedUsersAtom);
        const usersMap = get(usersMapAtom);
        const dates = get(datesAtom);
        
        // Создаем строку для каждого выбранного пользователя
        const userRows = selectedUsers.map(userId => {
            const user = usersMap[userId] || { label: userId, value: userId };
            const userRow = {
                parameters: {
                    resultGroup: RESULT_GROUP_WORKER,
                    key: String(userId)
                },
                extra: {
                    createdById: String(userId),
                    createdByDisplay: user.label || String(userId),
                    issueKey: '',
                    issueDisplay: '',
                    issueTitle: '',
                    issueTypeId: '',
                    issueTypeKey: '',
                    issueTypeDisplay: '',
                    projectId: '',
                    projectName: '',
                    queue: '',
                    queueName: '',
                    epicKey: '',
                    epicDisplay: '',
                },
                title: user.label || String(userId),
                byDate: {},
                value: 0,
                byCreatedBy: {},
                depth: 0,
                isMaxDepth: true,
                sub: {}
            };
            
            // Инициализируем byDate для всех дат
            dates.forEach(date => {
                userRow.byDate[date.index] = {
                    value: 0,
                    byCreatedBy: {},
                    details: []
                };
            });
            
            return userRow;
        });
        
        // Вставляем строки пользователей перед строкой "Итого"
        const totalRow = rows.find(r => r.isSummary);
        const otherRows = rows.filter(r => !r.isSummary);
        return [...otherRows, ...userRows, totalRow];
    }
    
    return rows;
});